import { v3ApiClient } from '@/client/services/api/clients/v3ApiClient';
import { learnApiClient } from '@/client/services/api/clients/learnApiClient';

const getGroupPrivileges = async (): Promise<{ enableProTier: boolean }> => {
  const response = await v3ApiClient.get('companyintegrations');

  const companyIntegration = response.data.length > 0 ? response.data[0] : null;
  if (!companyIntegration?.continu_insights?.privileges) {
    return {
      enableProTier: false,
    };
  }
  return companyIntegration.continu_insights.privileges;
};

const unsubscribeUser = async (): Promise<void> => {
  await learnApiClient.post('continu-insights/unsubscribe');
};

const ContinuInsightsService = {
  getGroupPrivileges,
  unsubscribeUser,
};

export default ContinuInsightsService;
